import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../../UI/PrimaryButton/PrimaryButton";
import OrderTypeBox from "./OrderType/OrderType";
import NewOrderModal from "./NewOrderModal/NewOrderModal";
import { useDispatch, useSelector } from "react-redux";
import { selectOrderTypes, selectSeats } from "../../../redux/finalOrder";
import { changeActiveCart } from "../../../redux/cart";
import { useTranslation } from "react-i18next";
import classes from "./NewOrder.module.scss";

const ORDERTYPES = [
  {
    engText: "Dine In",
    arabicText: "تناول الطعام في المطعم",
    icon: "dine-in",
  },
  {
    engText: "Takeaway",
    arabicText: "طلبات خارجية",
    icon: "order-bag",
  },
  {
    engText: "Delivery",
    arabicText: "توصيل",
    icon: "truck",
  },
  {
    engText: "Scheduled Orders",
    arabicText: "جدولة الطلب",
    icon: "shceduled-orders",
  },
  {
    engText: "Table Reservaion",
    arabicText: "حجز طاولة",
    icon: "reservation-table",
  },
];

const lowerFirstLetter = (string) => {
  return (
    string.charAt(0).toLocaleLowerCase() +
    string.replace(" ", "").split("").splice(1).join("")
  );
};

const NewOrder = () => {
  const { t } = useTranslation();
  const { orderTypes } = useSelector((state) => state.finalOrder);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedOrderTypes, setSelectedOrderTypes] = useState({
    dineIn: orderTypes.includes("dineIn"),
    takeaway: orderTypes.includes("takeaway"),
    delivery: orderTypes.includes("delivery"),
    scheduledOrdersItems: orderTypes.includes("scheduledOrdersItems"),
    tableReservaionItems: orderTypes.includes("tableReservaionItems"),
  });
  const [showModal, setShowModal] = useState(false);

  const orderTypeChangeHandler = (newOrderType) => {
    const updatedKey = lowerFirstLetter(newOrderType);
    setSelectedOrderTypes((oldState) => {
      return { ...oldState, [updatedKey]: !oldState[updatedKey] };
    });
  };

  const startOrder = () => {
    if (selectedOrderTypes.dineIn) {
      return setShowModal(true);
    }

    updateOrder();
  };

  const updateOrder = (seats) => {
    const orderTypes = Object.keys(selectedOrderTypes).filter(
      (orderKey, index) => {
        return selectedOrderTypes[orderKey];
      }
    );
    dispatch(selectOrderTypes(orderTypes));
    dispatch(changeActiveCart(orderTypes[0]));

    if (!selectedOrderTypes.dineIn) {
      return navigate("/orders/categories");
    }

    dispatch(selectSeats(seats));
    navigate("/zones?groupOf=" + seats);
  };

  const orderStatus = () => {
    return Object.values(selectedOrderTypes).every((status) => !status);
  };

  let modal = null;

  if (showModal) {
    modal = (
      <NewOrderModal
        onClosed={() => setShowModal(false)}
        onConfirm={updateOrder}
      />
    );
  }

  return (
    <div>
      <h2>{t("READY_TO_ORDER")}</h2>
      {modal}
      <div className={classes.OrderTypes}>
        {ORDERTYPES.map((orderType, index) => {
          return (
            <OrderTypeBox
              index={index + 1}
              key={orderType.engText}
              icon={orderType.icon}
              engText={orderType.engText}
              arabicText={orderType.arabicText}
              onClicked={orderTypeChangeHandler}
              isSelected={
                selectedOrderTypes[lowerFirstLetter(orderType.engText)]
              }
            />
          );
        })}
      </div>
      <div className={classes.OrderButton}>
        <PrimaryButton
          index={4}
          text="Begin Order ابدأ الطلب"
          customClasses="mt-8 ml-auto"
          isDisabled={orderStatus()}
          onClicked={startOrder}
        />
      </div>
    </div>
  );
};

export default NewOrder;
